import { type ReactNode } from "react";
import { type AddOnStrings } from "screens/offer-bc/utils";
import { type ItemProps, Item } from "../item";
import { CoverageType } from "types/quote-types";
import { CancelForAnyReason } from "../cancel-for-any-reason";
import { CarCare } from "../car-care";
import { ExtremeSports } from "../extreme-sports";
import { useTranslation } from "react-i18next";
import { ItemsWrapper, Column } from "./styles";

type ItemComponentMap = {
  [key in CoverageType]?: (props: ItemProps) => ReactNode;
};

export interface AddOnItemsProps {
  addOns: AddOnStrings[];
  itemComponentMap?: ItemComponentMap;
  textCta?: boolean;
  columns?: boolean;
  inlineActionInfo?: boolean;
}

export const DEFAULT_COMPONENT_MAP: ItemComponentMap = {
  [CoverageType.cancelForAnyReason]: (props) => (
    <CancelForAnyReason {...props} />
  ),
  [CoverageType.car]: (props) => <CarCare {...props} />,
  [CoverageType.sportsExtreme]: (props) => <ExtremeSports {...props} />,
};

export function AddOnItems({
  addOns,
  textCta,
  columns,
  inlineActionInfo,
}: AddOnItemsProps) {
  const { t } = useTranslation("screens", { keyPrefix: "offer" });

  const middleAddOnIndex = Math.ceil(addOns?.length / 2);
  const columnOneItems = addOns?.slice(0, middleAddOnIndex);
  const columnTwoItems = addOns?.slice(middleAddOnIndex);

  return (
    <ItemsWrapper className={columns ? "columns" : ""}>
      {Boolean(columnOneItems.length) && (
        <Column>
          {columnOneItems.map((addOn) => {
            const ItemComponent =
              DEFAULT_COMPONENT_MAP?.[addOn.coverageType] ?? Item;
            return (
              <ItemComponent
                key={addOn.coverageType}
                ctaTextValues={
                  textCta
                    ? [t("addOns.addCtaActivated"), t("addOns.addCta")]
                    : null
                }
                inlineActionInfo={inlineActionInfo}
                {...addOn}
              />
            );
          })}
        </Column>
      )}
      {Boolean(columnTwoItems.length) && (
        <Column>
          {columnTwoItems.map((addOn) => {
            const ItemComponent =
              DEFAULT_COMPONENT_MAP?.[addOn.coverageType] ?? Item;
            return (
              <ItemComponent
                key={addOn.coverageType}
                ctaTextValues={
                  textCta
                    ? [t("addOns.addCtaActivated"), t("addOns.addCta")]
                    : null
                }
                inlineActionInfo={inlineActionInfo}
                {...addOn}
              />
            );
          })}
        </Column>
      )}
    </ItemsWrapper>
  );
}
